// extracted by mini-css-extract-plugin
module.exports = {"title":"passport_title__o9-98","div":"passport_div__ITl4h","edit":"passport_edit__2DUw3"};